export default {"src":"/_next/static/media/sadInactive_24.11955023.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};